import { render, staticRenderFns } from "./TableHeadAddresses.vue?vue&type=template&id=503225fc&scoped=true"
import script from "./TableHeadAddresses.vue?vue&type=script&lang=ts"
export * from "./TableHeadAddresses.vue?vue&type=script&lang=ts"
import style0 from "./TableHeadAddresses.vue?vue&type=style&index=0&id=503225fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503225fc",
  null
  
)

export default component.exports